export default __webpack_public_path__ + "aa8620e082c6d6d761e2f913fc5f5d75.png";